import React from "react";
import PropTypes from "prop-types";
import config from "../../res/config.json";
import {
  roundTotalMonthlyFeeByCountry,
  formatNumber,
  truncateText,
  capitalizeFirstLetter,
} from "../../logic/GeneralFunctions";
import { format } from "date-fns";
import { cssStyles } from "./pdfHireAgreementStyles";

export default class CreateHireAgreement extends React.Component {
  static propTypes = {
    formInformation: PropTypes.object,
    customerInformation: PropTypes.object,
    productsValues: PropTypes.object,
    accessories: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    labels: PropTypes.object,
    params: PropTypes.object,
    paymentId: PropTypes.string,
  };

  render() {
    const today = new Date();
    const formattedDate = format(today, "yyyy-MM-dd");
    const lang = this.props.params.lang.toLowerCase();
    const formType = this.props.params.formType.toLowerCase();

    const {
      formInformation,
      customerInformation,
      productsValues,
      accessories,
      labels,
      paymentId,
    } = this.props;

    const { contractNumber, contractLength, totalMonthlyFee } = formInformation;
    const {
      customerName,
      customerGeneralContact,
      customerEmail,
      customerInvoiceEmail,
      companyNumber,
    } = customerInformation;

    const currencySymbol = labels.currencySymbol;
    const currencyAfterAmount = lang === "se" || lang === "no" || lang === "dk";
    const exclVat = (labels.ex_vat || "").replace(/[()]/g, "").trim();
    const formattedFee = formatNumber(
      roundTotalMonthlyFeeByCountry(lang, totalMonthlyFee, formType),
      lang,
      formType,
    );

    const directDebitLink = paymentId
      ? `https://eu.adyen.link/${paymentId}`
      : "";

    const productRows = Object.values(productsValues).filter(
      (product) => product.name,
    );
    const accessoryRows = Object.values(accessories || {}).filter(
      (accessory) => accessory.AccessoriesName,
    );

    return (
      <div className="wrapper">
        <style>{cssStyles}</style>
        <div id="hireAgreementPdf" className="hire-body">
          <div className="hire-header">
            <img
              src={
                config.ROOT +
                `getimage?company=hcs&country=images&type=logo_group.png`
              }
              alt="Husqvarna Group"
              width="10%"
            />
            <div className="hire-title">{labels.hire_agreement_title}</div>
          </div>

          <p className="hire-paragraph">{labels.dear_customer}</p>

          <p className="hire-paragraph">{labels.hire_agreement_text}</p>

          <table className="hire-table">
            <tbody>
              <tr>
                <td className="hire-label-cell">
                  {labels.label_contract_number}:
                </td>
                <td className="hire-value-cell">{contractNumber}</td>
              </tr>
              <tr>
                <td className="hire-label-cell">
                  {labels.label_customer_name}:
                </td>
                <td className="hire-value-cell">
                  {capitalizeFirstLetter(customerName) + ` (${companyNumber})`}
                </td>
              </tr>
              <tr>
                <td className="hire-label-cell">
                  {labels.label_customer_contact}:
                </td>
                <td className="hire-value-cell">
                  {capitalizeFirstLetter(customerGeneralContact)} (
                  {customerEmail})
                </td>
              </tr>
              <tr>
                <td className="hire-label-cell">{labels.product_fee}:</td>
                <td className="hire-value-cell">
                  {currencyAfterAmount ? (
                    <>
                      {formattedFee} {currencySymbol} {exclVat}
                    </>
                  ) : (
                    <>
                      {currencySymbol} {formattedFee} {exclVat}
                    </>
                  )}
                </td>
              </tr>
              <tr>
                <td className="hire-label-cell">
                  {labels.customer_invoice_email}:
                </td>
                <td className="hire-value-cell">{customerInvoiceEmail}</td>
              </tr>
              <tr>
                <td className="hire-label-cell">
                  {labels.label_contract_duration}:
                </td>
                <td className="hire-value-cell">
                  {contractLength} {labels.months}
                </td>
              </tr>
              <tr>
                <td className="hire-label-cell">{labels.products}:</td>
                <td className="hire-value-cell">
                  {productRows.map((product, index) => (
                    <div className="hire-product-row" key={`product-${index}`}>
                      {product.quantity} {truncateText(product.name, 50)}
                    </div>
                  ))}
                  {accessoryRows.map((accessory, index) => (
                    <div
                      className="hire-product-row"
                      key={`accessory-${index}`}
                    >
                      {accessory.AccessoriesQuantity || 1}{" "}
                      {truncateText(accessory.AccessoriesName, 50)}
                    </div>
                  ))}
                </td>
              </tr>
            </tbody>
          </table>

          <p className="hire-paragraph">
            {labels.formal_contract} {capitalizeFirstLetter(customerName)}
            {labels.formal_contract_approved}
          </p>

          <p className="hire-paragraph">{labels.additional_documentation}</p>

          {directDebitLink && (
            <div className="hire-direct-debit">
              <div className="hire-direct-debit-title">
                {labels.direct_debit_title.toUpperCase()}{" "}
                <span className="hire-direct-debit-recommended">
                  {labels.direct_debit_recommended}
                </span>
              </div>

              <p className="hire-paragraph">
                {labels.direct_debit_description}
              </p>

              <p className="hire-paragraph">
                {labels.direct_debit_instructions}{" "}
                <a className="hire-direct-debit-link" href={directDebitLink}>
                  {labels.direct_debit_title} &ndash; {contractNumber}
                </a>
              </p>
              <p className="hire-paragraph-small">
                {`(${labels.direct_debit_link_validity + " " + formattedDate})`}
              </p>
            </div>
          )}

          <p className="hire-paragraph">{labels.thank_lease_plus_pro}</p>
        </div>
      </div>
    );
  }
}
